export default __webpack_public_path__ + "static/media/dty.78acc459.jpg";